import {IReviewResultSubQuestion} from "./IReviewResultSubQuestion";
export class IReviewResultQuestion {
  description: string;
  __questions:Array<IReviewResultSubQuestion>;
}
